import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { MissionDetailForAuthorizedUser, MissionDetailForUnauthorizedUser } from '@/features/missions/MissionsWrappers'
import { Page } from '@/ui-kit'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { useParams } from 'react-router-dom'

const MissionDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        {jwt ? (
          <MissionDetailForAuthorizedUser missionId={id ?? ''} />
        ) : (
          <MissionDetailForUnauthorizedUser missionId={id ?? ''} />
        )}
      </Page>
    </MissionsUrlProvider>
  )
}

export default MissionDetailPage
